import React from 'react'
import Navbar from './navbar'
import { Scroll } from 'react-fns'

const NavbarWrapper = () => (
  <Scroll throttle={0}>{({ y }) => <Navbar scrolled={y > 50} />}</Scroll>
)

export default NavbarWrapper
